import { forwardRef } from "react";
import {
  Badge,
  Box,
  Button,
  HStack,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Text,
  VStack,
} from "@chakra-ui/react";
import { FaHeadphones, FaHeadphonesSimple } from "react-icons/fa6";
import { HiPlus, HiPlusCircle } from "react-icons/hi2";
import { RiPlayList2Fill, RiPlayListLine } from "react-icons/ri";
import { useNavigate } from "react-router";
import usePlaylist from "../../hooks/data/usePlaylist";
import useUserStore from "../../store/userStore";
import { shallow } from "zustand/shallow";
import { useGrooveRoom } from "../../wrappers/grooveRoom";
import { useStripe } from "../../wrappers/stripe";
import { IoCubeSharp } from "react-icons/io5";
import { TbMusic } from "react-icons/tb";

const CreateButton = () => {
  const navigate = useNavigate();
  const { addNewPlaylist } = usePlaylist();
  // const { addNewRoom } = useGrooveRoom();
  const { uid, username } = useUserStore((state) => state.user, shallow);
  const { LockedFeature } = useStripe();

  async function _createPlaylist() {
    const newPlaylist = await addNewPlaylist();
    navigate(`/user/${username}/playlist/${newPlaylist.id}`);
  }

  async function createGrooveRoom() {
    const newRoom = await addNewRoom();
    navigate(`/room/${newRoom.id}`);
  }

  return (
    <Menu placement="auto">
      <MenuButton
        as={Button}
        variant={"nav"}
        leftIcon={<HiPlus />}
        w="full"
        border="1px dashed"
        borderColor={"gray.600"}
        bg="transparent"
        transition={"none"}
        cursor={"pointer"}
        textAlign={'left'}
      >
        New
      </MenuButton>
      <MenuList color={"white"} p="1" w="300px">
        <MenuItem onClick={() => navigate(`/create/post`)}>
          <VStack w={"full"} align={"flex-start"} spacing={"1"}>
            <HStack>
              <TbMusic />
              <Text fontSize={"13px"} fontWeight={"semibold"} noOfLines={"2"}>
                New Track
              </Text>
            </HStack>
            <Text fontSize={"12px"} color="gray.400">
              Singles, sound effects, albums & more
            </Text>
          </VStack>
        </MenuItem>
        <LockedFeature checkConnectAccountStatus>
          <MenuItem onClick={() => navigate(`/create/product`)}>
            <VStack w={"full"} align={"flex-start"} spacing={"1"}>
              <HStack>
                <IoCubeSharp />
                <Text fontSize={"13px"} fontWeight={"semibold"} noOfLines={"2"}>
                  New Product
                </Text>
              </HStack>
              <Text fontSize={"12px"} color="gray.400">
                Merch, concert tickets, gift cards & more
              </Text>
            </VStack>
          </MenuItem>
        </LockedFeature>
        <MenuDivider />
        <MenuItem onClick={_createPlaylist}>
          <VStack w={"full"} align={"flex-start"} spacing={"1"}>
            <HStack>
              <RiPlayListLine />
              <Text>New Playlist</Text>
            </HStack>
            <Text fontSize={"12px"} color="gray.400">
              Keep your loved beats in one place
            </Text>
          </VStack>
        </MenuItem>
        {/* <LockedFeature>
          <MenuItem onClick={createGrooveRoom}>
            <FaHeadphonesSimple />
            <HStack w="full" justify={"space-between"}>
              <Text>New GrooveRoom</Text>
            </HStack>
          </MenuItem>
        </LockedFeature> */}
      </MenuList>
    </Menu>
  );
};
export default CreateButton;
